import { InitialsCombinedProps } from './types';

const usePresenter = (props: InitialsCombinedProps): InitialsCombinedProps => {
  return props;
};

export default usePresenter;
